module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-wink.e958e6c1.svg";